<template>
  <div>
    <div class="d-flex flex-column flex-md-row justify-content-between mb-3">
      <div class="d-flex flex-column flex-wrap mb-2 mb-md-0" style="gap: 8px;">
        <div class="d-flex flex-wrap align-items-center" style="gap: 4px;">
          <button class="btn mr-2" :class="{'btn-primary': typeFilter.includes('TEAM')}"
                  @click="toggleType('TEAM')">{{ $t('select.options.TEAM') }}
          </button>
          <button class="btn mr-2" :class="{'btn-primary': typeFilter.includes('FREE_AGENT')}"
                  @click="toggleType('FREE_AGENT')">{{ $t('select.options.FREE_AGENT') }}
          </button>
        </div>
        <div class="d-flex flex-wrap align-items-center" style="gap: 4px;">
          <button class="btn mr-2" :class="{'btn-success': statusFilter.includes('PENDING')}"
                  @click="toggleStatus('PENDING')"><span class="mr-1">{{ $t('statusBadge.pending') }}</span> <span class="badge badge-info" :class="{'bg-white text-black': statusFilter.includes('PENDING')}">{{ model.meta?.countByStatus?.PENDING || 0 }}</span>
          </button>
          <button class="btn mr-2" :class="{'btn-success': statusFilter.includes('APPROVED')}"
                  @click="toggleStatus('APPROVED')"><span class="mr-1">{{ $t('statusBadge.approved') }}</span> <span class="badge badge-info" :class="{'bg-white text-black': statusFilter.includes('APPROVED')}">{{ model.meta?.countByStatus?.APPROVED || 0 }}</span>
          </button>
          <button class="btn mr-2" :class="{'btn-success': statusFilter.includes('REJECTED')}"
                  @click="toggleStatus('REJECTED')"><span class="mr-1">{{ $t('statusBadge.rejected') }}</span> <span class="badge badge-info" :class="{'bg-white text-black': statusFilter.includes('REJECTED')}">{{ model.meta?.countByStatus?.REJECTED || 0 }}</span>
          </button>
        </div>
      </div>

      <input type="text" class="form-control" style="max-width: 300px" :placeholder="$t('search')" v-model="search">
    </div>
    <div class="position-relative" style="min-height: 400px">
      <le-loading v-if="loading"></le-loading>
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-vcenter">
          <thead>
          <tr>
            <th>{{ $t('team_application.applicationNumber') }}</th>
            <th>Team</th>
            <th>Contact</th>
            <th>Status</th>
            <th></th>
            <th class="text-center" style="width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(teamApplication, index) in model.data" :key="index">
            <td class="fs-sm text-muted fw-semibold" style="white-space: nowrap;">
              #{{ teamApplication.applicationNumber }}
              <br>
              <span class="badge text-uppercase fs-xs mt-1"
                    :class="teamApplication.type === 'TEAM' ? 'badge-primary' : 'badge-info'">
                {{ $t(`select.options.${teamApplication.type}`) }}
              </span>
            </td>
            <td class="fw-semibold fs-sm">
              <router-link
                :to="{ name: 'teamApplication.show', params: { applicationWindow: applicationWindowUuid, teamApplication: teamApplication.uuid } }"
                class="link-fx fs-3 font-w600">{{ teamApplication.teamName }}
              </router-link>
              <br>
              <span class="font-w400">{{ teamApplication.category }}</span><br>
            </td>
            <td class="fs-sm">
              <span class="font-size-sm">{{ teamApplication.managerName }}</span><br>
              <span><a :href="`mailto:${teamApplication.managerEmail}`">{{
                  teamApplication.managerEmail
                }}</a></span><br>
              <span><a
                :href="`tel:${teamApplication.managerPhoneNumber}`">{{ teamApplication.managerPhoneNumber }}</a></span>
            </td>
            <td>
            <span class="fs-xs fw-semibold d-inline-block badge px-2 py-1 text-uppercase" :class="getStatusClass(teamApplication.status)">
              {{ $t(`select.options.${teamApplication.status}`) }}
            </span>
            </td>
            <td>
              <span>
                {{ $tc('coach.name', 2) }}: {{ teamApplication.coachesCount }}<br>
                {{ $tc('player.name', 2) }}: {{ teamApplication.playersCount }}
              </span>
            </td>
            <td class="text-center">
              <div class="btn-group">
                <router-link
                  :to="{ name: 'teamApplication.show', params: { applicationWindow: applicationWindowUuid, teamApplication: teamApplication.uuid } }"
                  class="btn btn-sm btn-primary"
                  v-tooltip="$t('action.edit')">
                  <i class="fa fa-eye"></i>
                </router-link>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="model.meta" class="row mt-2 justify-content-between">
        <div class="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
          <div class="dt-info" aria-live="polite" id="DataTables_Table_0_info" role="status">
            <strong>{{ model.meta.current_page }}</strong> of <strong>{{ model.meta.last_page }}</strong></div>
        </div>
        <div class="d-md-flex justify-content-between align-items-center dt-layout-end col-md-auto ms-auto">
          <div class="dt-paging paging_simple_numbers">
            <nav aria-label="pagination">
              <ul class="pagination">
                <li class="dt-paging-button page-item" :class="{'disabled': this.page === 1}">
                  <button class="page-link previous" role="link" type="button" @click="previousPage" tabindex="-1" v-tooltip="$t('tooltip.previous')"><i
                    class="fa fa-angle-left"></i></button>
                </li>
                <li class="dt-paging-button page-item" :class="{'active': i === model.meta.current_page }"
                    v-for="i in model.meta.last_page" :key="i">
                  <button class="page-link" role="link" type="button" @click="setPage(i)">
                    {{ i }}
                  </button>
                </li>
                <li class="dt-paging-button page-item" :class="{'disabled': this.page === this.model.meta.last_page}">
                  <button class="page-link next" role="link" type="button" @click="nextPage" v-tooltip="$t('tooltip.next')"><i
                    class="fa fa-angle-right"></i></button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplicationWindowService from '@/services/applicationWindow.service'
import { debounce } from 'lodash'
import LeLoading from '@/components/ntm/LeLoading.vue'
import { useRouteQuery } from '@/use/useRouteQuery'

export default {
  name: 'TeamApplications',
  components: { LeLoading },
  props: {
    applicationWindowUuid: {
      type: String,
      required: true
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      search: '',
      model: {
        data: null,
        meta: null
      },
      loading: false,
      page: 1,
      debouncedFetch: null
    }
  },
  computed: {
    statusFilter: {
      get () {
        return this.statuses ? this.statuses.split(',') : []
      },
      set (value) {
        this.statuses = value
      }
    },
    typeFilter: {
      get () {
        return this.types ? this.types.split(',') : []
      },
      set (value) {
        this.types = value
      }
    }
  },
  setup () {
    const statuses = useRouteQuery('statuses')
    const types = useRouteQuery('types')
    return {
      statuses,
      types
    }
  },
  mounted () {
    this.debouncedFetch = debounce(this.fetchData, 700)
    this.fetchData()
  },
  watch: {
    categories () {
      this.page = 1
      this.debouncedFetch()
    },
    statuses () {
      this.page = 1
      this.debouncedFetch()
    },
    types () {
      this.page = 1
      this.debouncedFetch()
    },
    search () {
      this.page = 1
      this.debouncedFetch()
    }
  },
  methods: {
    toggleStatus (status) {
      const statuses = [...this.statusFilter]
      const index = statuses.findIndex(s => s === status)

      if (index > -1) {
        statuses.splice(index, 1)
      } else {
        statuses.push(status)
      }

      if (statuses.length === 0) {
        this.statuses = null
      } else {
        this.statuses = statuses.join(',')
      }
    },
    toggleType (type) {
      const types = [...this.typeFilter]
      const index = types.findIndex(t => t === type)

      if (index > -1) {
        types.splice(index, 1)
      } else {
        types.push(type)
      }

      if (types.length === 0) {
        this.types = null
      } else {
        this.types = types.join(',')
      }
    },
    getStatusClass (status) {
      return {
        'badge-success': status === 'APPROVED',
        'badge-danger': status === 'REJECTED',
        'badge-warning': status === 'PENDING'
      }
    },
    nextPage () {
      if (this.page < this.model.meta.last_page) {
        this.page++
        this.fetchData()
      }
    },
    previousPage () {
      if (this.page > 1) {
        this.page--
        this.fetchData()
      }
    },
    setPage (page) {
      this.page = page
      this.fetchData()
    },
    setData (data) {
      this.model = data
    },
    fetchData () {
      this.loading = true
      ApplicationWindowService.teamApplications(this.applicationWindowUuid, {
        categories: this.categories,
        statuses: this.statusFilter,
        types: this.typeFilter,
        page: this.page,
        search: this.search
      }).then((response) => {
        this.setData(response.data)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
